import { useMemo } from 'react'
import { resolveComputedDisplayName, type DisplayNameSource } from '../utils/userIdentity'

export const useDisplayName = (user: DisplayNameSource): string =>
  useMemo(() => resolveComputedDisplayName(user), [user])
